// extracted by mini-css-extract-plugin
export default {"mark":"ProviderMarks_mark__TZUkA"};